if (!window.customElements.get('ugc-video')) {
  class UgcVideo extends HTMLElement {
    connectedCallback() {
      const clearSpinnerTimer = () => {
        if (this._spinnerTimer) {
          clearTimeout(this._spinnerTimer);
          this._spinnerTimer = null;
        }
      };
      const setLoading = (loading) => {
        if (!loading) clearSpinnerTimer();
        this.dataset.loading = loading ? 'true' : 'false';
      };
      const scheduleSpinner = (delay = 150) => {
        clearSpinnerTimer();
        this._spinnerTimer = setTimeout(() => { this.dataset.loading = 'true'; }, delay);
      };

      this._video = this.querySelector('video');
      if (this._video) {
        this._video.playsInline = true;
        this._video.addEventListener('play', () => {
          this.dataset.state = 'playing';
          const scope = this.closest('.ugc-videos') || document;
          scope.querySelectorAll('ugc-video').forEach((el) => {
            if (el === this) return;
            const v = el.querySelector('video');
            if (v && !v.paused) v.pause();
          });
        });
        this._video.addEventListener('playing', () => { this.dataset.state = 'playing'; setLoading(false); });
        this._video.addEventListener('pause', () => { this.dataset.state = 'paused'; setLoading(false); });
        this._video.addEventListener('ended', () => { this.dataset.state = 'paused'; setLoading(false); });
        this._video.addEventListener('waiting', () => { scheduleSpinner(0); });
        this._video.addEventListener('error', () => { setLoading(false); });
      }

      const toggle = () => {
        if (!this._video) return;
        if (this._video.paused) {
          scheduleSpinner(150);
          try {
            const result = this._video.play();
            if (result && typeof result.catch === 'function') {
              result.catch(() => { setLoading(false); });
            }
          } catch (err) {
            setLoading(false);
          }
        } else {
          this._video.pause();
        }
      };

      // Click anywhere on the card toggles play/pause, except on the
      // creator handle link, which should still navigate.
      this.addEventListener('click', (e) => {
        if (e.target.closest('a, [data-no-toggle]')) return;
        e.preventDefault();
        toggle();
      });

      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest('a, [data-no-toggle]')) return;
        e.preventDefault();
        toggle();
      });
    }
  }
  customElements.define('ugc-video', UgcVideo);
}
